import React from 'react';
import {Form, Formik} from 'formik';
import {useTranslation} from 'react-i18next';
import LightGreenButton from '../../../Components/Buttons/LightGreenButton';
import GreenButton from '../../../Components/Buttons/GreenButton';
import FilterBySixMonths from '../../../Components/Filter/Components/FilterBySixMonths';
import {monthNow} from '../../../assets/utils/dateUtils';
import {scrollToTop, submitFilterFieldCleaner} from '../../../assets/utils/utils';

type Props = {
	active: boolean;
	setActive: (active: boolean) => void;
	setMonth: (month: string) => void;
	currentMonth: string;
};

const RegistrationListFilter: React.FC<Props> = ({
	active,
	setActive,
	setMonth,
	currentMonth,
}) => {
	const {t} = useTranslation();
	
	const initialValues = {
		month: currentMonth || monthNow(),
	};

	const handleSubmit = (values: {month: string}) => {
		const filteredValues = submitFilterFieldCleaner(values);
		if (filteredValues.month) {
			setMonth(filteredValues.month);
		}
		setActive(false);
		scrollToTop('smooth');
	};

	return (
		<div
			className={`filter-team__filter-item item-filter ${!active ? '' : 'active'}`}
		>
			<div className="item-filter__wrapper">
				<Formik
					enableReinitialize
					initialValues={initialValues}
					onSubmit={handleSubmit}
				>
					{({handleSubmit, resetForm, setFieldValue}) => {
						return (
							<Form onSubmit={handleSubmit}>
								<FilterBySixMonths
									setFieldValue={setFieldValue}
									initialMonth={currentMonth}
								/>
								<div className="item-filter__buttons">
									<LightGreenButton text={t('застосувати')} type={'submit'} />
									<GreenButton
										text={t('скасувати фільтр')}
										type={'button'}
										onClick={() => {
											setMonth(monthNow());
											resetForm();
										}}
									/>
								</div>
							</Form>
						);
					}}
				</Formik>
			</div>
		</div>
	);
};

export default RegistrationListFilter;

